import { render, staticRenderFns } from "./fastAddCar.vue?vue&type=template&id=53b97d0c"
import script from "./fastAddCar.vue?vue&type=script&lang=js"
export * from "./fastAddCar.vue?vue&type=script&lang=js"
import style0 from "./fastAddCar.vue?vue&type=style&index=0&id=53b97d0c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports